import { makeStyles } from "@material-ui/styles";

const teamComparisonStyles = makeStyles(() => ({
	column: {
		width: "33.3%"
	},
	sectionSubtitle: {
		fontWeight: 400,
		fontSize: 16
	}
}));

export default teamComparisonStyles;
